<template>
  <div
    class="bb-contact-form-partner"
    :class="[editable && 'bb-contact-form-partner_edit']"
  >
    <label class="bb-form__label bb-contact-form-partner__label">Partner</label>
    <BBSelectInput
      v-if="editable"
      class="bb-contact-form-partner__select"
      :input="input"
      :model="model"
      @input="onChange"
    />
    <div
      v-else
      class="bb-contact-form-partner__text"
    >
      {{ name }}
    </div>
  </div>
</template>

<script>
import ContactsApi from '@/api/Contacts/api'
import BBSelectInput from '@/components/Main/Form/BBSelectInput/BBSelectInput'
import {get} from 'lodash'

export default {
  name: 'ContactFormPartner',
  components: {
    BBSelectInput
  },
  props: {
    editable: {
      type: Boolean,
      default: false
    },
    client: {
      type: Object,
      default: () => ({})
    }
  },
  data: () => ({
    input: {
      model: 'partner',
      placeholder: 'not assigned',
      listLabel: 'nickName',
      searchable: true,
      searchableBy: 'nickName',
      options: []
    },
    model: {
      partner: undefined
    }
  }),
  computed: {
    name () {
      const partner = get(this.client, 'partner', '');
      if (typeof partner === 'string') {
        const partnerDetails = get(this.client, 'partnerDetails', []);
        const partnerUser = partnerDetails.find(({_id}) => _id === partner)
        return get(partnerUser, 'nickName', '')
      }
      return get(this.client, 'partner.nickName', '')
    },
    partner () {
      const partner = get(this.client, 'partner', '');
      if (typeof partner === 'string') {
        const partnerDetails = get(this.client, 'partnerDetails', []);
        const partnerUser = partnerDetails.find(({_id}) => _id === partner)
        return partnerUser
      }
      return get(this.client, 'partner', '')
    }
  },
  methods: {
    onChange (item) {
      this.client.partner = item
    },
    async getPartners () {
      const body = {
        contactType: '&contactType[]=2'
      }
      try {
        const { data } = await ContactsApi.getClientsSelect(body)
        const notAssigned = {
          id: 'not assigned',
          nickName: 'not assigned'
        }
        this.input.options = [notAssigned, ...data]
      } catch (err) {
        console.error(err)
      }
    }
  },
  beforeMount () {
    this.getPartners()
    this.model.partner = this.partner
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../../../sass/variables";

  .bb-contact-form-partner {
    display: flex;
    position: relative;
    justify-content: space-between;
    align-items: center;
    height: auto;
    min-height: auto;
    margin: 0 20px;
    padding: 13px 0;
    border-bottom: 1px solid $color-wild-sand;

    &_edit {
      margin: 0 0 18px 0;
      padding: 0 20px 0 25px;
      border-bottom: 0;
    }

    &__label {
      font-weight: 600;
      font-size: 13px;
      line-height: 16px;
      min-width: 180px;
    }

    &__text {
      font-weight: normal;
      font-size: 13px;
      line-height: 16px;
    }

    &__select {
      width: 100%;
    }
  }
</style>

<style lang="scss">
@import "../../../../../../sass/variables";

  .bb-contact-form-partner__select {

    .bbp-select-header {
      border: 1px solid $color-wild-sand !important;
      min-height: 32px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCard/ContactForm/ContactFormPartner.vue